import React from "react";
import Welcome from "./Welcome";
import Trainings from '../Trainings/Trainings'

export default function Home() {
  return (
    <div id="home">
      <Welcome />
      <Trainings />
    </div>
  );
}
